import { createSelector } from 'reselect';
import { permissionsSelector } from 'app/UserInfo/selectors';
import ability from '../ability';
import { read } from '../const';

export default (report, state) => {
  const selector = createSelector(
    () => report,
    permissionsSelector,
    (component, permissions) =>
      ability.can({
        read,
        report,
        permissions
      })
  );
  return selector(state);
};
